
const TeacherInfo = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Teacher Image */}
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/d3b7c46da96557e5df43f8d994cf70c7.jpg"
                alt="Your English Teacher"
                className="w-full rounded-2xl shadow-lg object-cover object-top"
              />
              <div className="absolute -bottom-6 -right-6 bg-indigo-600 text-white p-4 rounded-xl shadow-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold">5+</div>
                  <div className="text-sm">Years Teaching</div>
                </div>
              </div>
            </div>

            {/* Teacher Description */}
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Hi! I'm Your Personal English Teacher
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                I'm passionate about helping people learn English in a fun, practical way. With over 5 years of teaching experience, 
                I've helped hundreds of students improve their English skills and gain confidence in speaking.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Personalized Learning Approach</h4>
                    <p className="text-gray-600">Every lesson is tailored to your specific needs and learning style</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Real-World Focus</h4>
                    <p className="text-gray-600">Learn practical English you'll actually use in daily conversations</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Flexible Scheduling</h4>
                    <p className="text-gray-600">Book lessons at times that work best for your schedule</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Immediate Feedback</h4>
                    <p className="text-gray-600">Get instant corrections and tips to improve faster</p>
                  </div>
                </div>
              </div>

              <div className="bg-indigo-50 rounded-xl p-6">
                <h4 className="font-semibold text-indigo-900 mb-2">My Teaching Philosophy</h4>
                <p className="text-indigo-700">
                  "Learning English should be enjoyable, not stressful. I believe in creating a comfortable environment 
                  where you feel confident to make mistakes and learn from them. Together, we'll make your English goals a reality!"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeacherInfo;
